export const TRANSIENT_HOA_FILE_KEYS = [
  '_pendingAssociationFiles',
  '_pendingManagementFiles',
  '_removedAssociationFileIds',
  '_removedManagementCompanyFileIds',
];

export const CLIENT_REQUEST_HOA_KEYS = ['name', 'managementCompany', 'phoneNumber', 'email'];

/** Client HOA text for requestHoaInfo — reference only, not directory-linked. */
export const serializeClientRequestHoaInfo = homeOwnerInformation =>
  (homeOwnerInformation || [])
    .map(hoa => {
      const entry = {};
      CLIENT_REQUEST_HOA_KEYS.forEach(key => {
        const val = String(hoa?.[key] || '').trim();
        if (val) entry[key] = val;
      });
      return entry;
    })
    .filter(h => h.name);

const REQUEST_HOA_LABELS = {
  name: 'HOA Name',
  managementCompany: 'Management Company',
  phoneNumber: 'Phone',
  email: 'Email',
};

export const REQUEST_HOA_DISPLAY_FIELDS = CLIENT_REQUEST_HOA_KEYS.map(key => ({
  key,
  label: REQUEST_HOA_LABELS[key],
}));

const stripPreferredFromContact = contact => {
  if (!contact || typeof contact !== 'object' || Array.isArray(contact)) return contact;
  const { preferred, defaultFor, ...rest } = contact;
  return rest;
};

const stripPreferredFromContactList = contacts =>
  Array.isArray(contacts) ? contacts.map(stripPreferredFromContact) : contacts;

/** Order save — omit star metadata; preferred contacts are set via Edit Association only. */
export const serializeHomeOwnerInformation = homeOwnerInformation =>
  (homeOwnerInformation || []).map(hoa => {
    const {
      _pendingAssociationFiles,
      _pendingManagementFiles,
      managementType,
      ...rest
    } = hoa || {};
    const serialized = { ...rest };
    if (managementType === 'self' || managementType === 'managed') {
      serialized.managementType = managementType;
    }
    if ('associationContacts' in serialized) {
      serialized.associationContacts = stripPreferredFromContactList(serialized.associationContacts);
    }
    if ('managementCompanyContacts' in serialized) {
      serialized.managementCompanyContacts = stripPreferredFromContactList(
        serialized.managementCompanyContacts
      );
    }
    return serialized;
  });

export const appendHoaSlotFiles = (formData, homeOwnerInformation) => {
  (homeOwnerInformation || []).forEach((hoa, index) => {
    (hoa?._pendingAssociationFiles || []).forEach(file => {
      if (file instanceof File) {
        formData.append(`associationFiles_${index}`, file, file.name);
      }
    });
    (hoa?._pendingManagementFiles || []).forEach(file => {
      if (file instanceof File) {
        formData.append(`managementCompanyFiles_${index}`, file, file.name);
      }
    });
  });
};

export const hasPendingHoaFiles = homeOwnerInformation =>
  (homeOwnerInformation || []).some(
    hoa => hoa?._pendingAssociationFiles?.length || hoa?._pendingManagementFiles?.length
  );
